import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { CreateTicketPage } from '@/components/Tickets/CreateTicketPage'
import { createTicketSearchSchema } from '@/components/Tickets/search'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/tickets/new/')({
  validateSearch: createTicketSearchSchema,
  component: NewTicketRoute,
})

function NewTicketRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <CreateTicketPage
      search={search}
      onSearchChange={(next) =>
        void navigate({ search: (current) => ({ ...current, ...next }), replace: true })
      }
    />
  )
}
